<template>

  <transition
    name="slide-left"
  >
    <div
      v-if="isMiniOpen"
      class="survey"
    >
      <div
        class="body-2"
        v-text="$t('survey.text')"
      />

      <basic-text-button
        class="survey__close"
        @click="closeMini"
      >
        <template #trailing>
          <the-icon
            art="solid"
            name="xmark"
          />
        </template>
      </basic-text-button>

      <basic-text-button
        :label="$t('survey.btn')"
        @click="openSurvey"
      >
        <template #trailing>
          <the-icon
            art="solid"
            name="arrow-right"
          />
        </template>
      </basic-text-button>
    </div>
  </transition>

  <basic-modal.container
    id="survey"
    ref="modalRef"
  >
    <basic-modal.step
      :id="surveyData.TP"
      type="raw"
    >
      <basic-modal.content>
        <iframe
          ref="surveyFrameRef"
          style="border: none"
          width="100%"
          height="500px"
          :src="target"
        />
      </basic-modal.content>

      <basic-modal.footer
      />
    </basic-modal.step>
  </basic-modal.container>
</template>

<script setup>
  import { computed, onBeforeMount, ref } from 'vue'

  import { BasicModal, BasicTextButton } from '@shared/components/Basic'

  import { CUSTOM_EVENT_SURVEY_TRIGGER } from '@shared/config/events'

  // DATA
  const modalRef = ref()
  const surveyFrameRef = ref()
  const isMiniOpen = ref(false)
  const surveyData = ref({
    Action: 'START_SURVEY',
    SurveyName: 'CUSTOMER_SATISFACTION',
    BID: '',
    L: null,
    TP: null,
    S: 'Web',
    Vepa: null,
    RiskAssessment: null,
    app: 'dvp'
  })

  // COMPUTED
  const target = computed(() => {
    const url = new URL(`${import.meta.env.VITE_SANITAS_RESOURCE_URI}kundenportal/shared/survey`)
    url.search = new URLSearchParams(surveyData.value)

    return url
  })

  // METHODS
  function closeMini() {
    isMiniOpen.value = false
  }

  function openSurvey() {
    closeMini()
    modalRef.value.open()

    window.setTimeout(() => {
      window.addEventListener('message', event => {
        if (event.data.type === 'surveyFinished') {
          modalRef.value.close()
        }
      })
    }, 501)
  }

  // LIFECYCLE HOOKS
  onBeforeMount(() => {
    window.addEventListener(CUSTOM_EVENT_SURVEY_TRIGGER, event => {
      const payload = event.detail
      surveyData.value.BID = payload.basketId
      surveyData.value.Vepa = payload.vepaNr
      surveyData.value.TP = payload.touchPoint
      surveyData.value.L = payload.language.toUpperCase()
      surveyData.value.RiskAssessment = payload.riskAssessment

      isMiniOpen.value = true
    })
  })
</script>

<style scoped>
  .survey {
    position: fixed;

    background-color: var(--on-primary);
    box-shadow: var(--elevation-level-3);
    top: 20%;
    right: 8px;

    height: 175px;
    width: 280px;
    padding: var(--fixed-spacing-fix-06);
    z-index: var(--dvp-stack-level-screen-blocker);
    display: flex;
    flex-direction: column;
    gap: 8px;
    border-radius: var(--radius-border-radius-02);

    .survey__close {
      position: absolute;
      right: 16px;
      top: 16px;
    }

    .survey__frame {
      width: 100%;
    }
  }
</style>

<style name="animations" scoped>
  .slide-left-enter-active,
  .slide-left-leave-active {
    overflow: hidden;
    transition: transform var(--duration-long-1) var(--ease-in-out-cubic);
  }

  .slide-left-enter-from {
    transform: translate(100%, 0);
  }
  .slide-left-leave-to {
    transform: translate(100%, 0);
  }
</style>
